import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class AppTranslateLoader implements TranslateLoader {
    constructor(private _http: HttpClient) { }

    getTranslation(lang: string): Observable<Record<string, unknown>> {
        return this._http.get<Record<string, unknown>>(`assets/i18n/${lang}.json`);
    }
}

export function createTranslateLoader(http: HttpClient): TranslateLoader {
    return new AppTranslateLoader(http);
}
